module.exports = __webpack_public_path__ + "img/Info Panel.4e3fc15b.png";